
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { SideMenuTopic } from '@/const/SideMenuTopic'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ButtonNavigation from '@/components/molecules/ButtonNavigation.vue'

/**
 * 左側メニューのベースレイアウト
 * 各権限で共通、メイン部分に表示する内容とインフォメーションパネルをslotで渡す
 */
@Component({
  components: {
    ImageBase,
    ButtonBase,
    ButtonNavigation,
  },
})
export default class SidemenuLayoutBase extends Vue {
  /** コンテンツメイン部のDOM要素 */
  @Ref()
  contentMain!: HTMLElement

  /** メニュー項目一覧 */
  @Prop()
  private topicList!: SideMenuTopic.Topic[]

  /** 現在ページのURL情報 */
  private url = new URL(window.location.href)

  /** メニューの展開状況 */
  private isOpen = true

  /**
   * 対象項目が現在表示中のページかを判定する
   *
   * @param topic サイドメニュー項目情報
   * @returns 表示中のページとURLが一致するか
   */
  private isCurrentPage(topic: SideMenuTopic.Topic): boolean {
    // urlが一致したらtrueを返し終了
    const regexA = new RegExp(`^${topic.url}$`)
    if (regexA.test(this.url.pathname)) {
      return true
    }

    // subUrlsが存在する場合、要素毎に判定し一致したらtrueを返す
    if (topic.subUrls) {
      for (let i = 0; i < topic.subUrls.length; i++) {
        const regexB = new RegExp(`^${topic.subUrls[i]}$`)
        if (regexB.test(this.url.pathname)) {
          return true
        }
      }
    }

    // 一致しなければ、falseを返す
    return false
  }

  /**
   * メニューの表示切り替え
   *
   * @param isOpen メニューの表示/非表示
   */
  private toggleMenu(isOpen: boolean): void {
    this.isOpen = isOpen
  }
}
